module.exports = __webpack_public_path__ + "img/sxmd.59e2e0de.jpg";